import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=8ed29b80&scoped=true&"
import script from "./MainMenu.vue?vue&type=script&lang=js&"
export * from "./MainMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=8ed29b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed29b80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ed29b80')) {
      api.createRecord('8ed29b80', component.options)
    } else {
      api.reload('8ed29b80', component.options)
    }
    module.hot.accept("./MainMenu.vue?vue&type=template&id=8ed29b80&scoped=true&", function () {
      api.rerender('8ed29b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/headers/shared/MainMenu.vue"
export default component.exports